import script from "./UpdateControllerItem.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateControllerItem.vue?vue&type=script&setup=true&lang=js"

import "./UpdateControllerItem.vue?vue&type=style&index=0&id=fa88ae1a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa88ae1a"]])

export default __exports__